import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { SignupData } from '../../SignupData';
import { LocaleSessionService } from '../../../shared/services/localeSession.service';
import { accountConfigurations } from '../../data/AccountConfigurations';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateModule],
})
// TODO find out what is this component and where is it really used for. Seems like its deprecated - I could not find on webpage the parent modal this is in
export class PricingComponent {
  private localeSession = inject(LocaleSessionService);

  @Input() data: SignupData;

  getPricing() {
    let cost = 0;

    Object.keys(this.data.configuration).forEach((key) => {
      const configuration = accountConfigurations.find((o) => o.name == key);
      const chosenConfiguration = this.data.configuration[key];

      if (!chosenConfiguration || !configuration) return;

      const configCost = configuration.data.find((o) => o.value == chosenConfiguration)?.cost;
      if (configCost && !isNaN(Number(configCost))) cost += Number(configCost);
    });

    return cost.toFixed(2);
  }

  getCurrency() {
    return this.localeSession.currency;
  }
}
